module.exports = __webpack_public_path__ + "img/bottom.fc96e285.png";